import React from 'react';
import { Paper, Skeleton, Box } from '@mui/material';

export default function LoadingBlock({ height = 300 }) {
  return (
    <Paper sx={{ p: 2 }}>
      <Skeleton variant="text" width="35%" height={28} sx={{ mb: 2 }} />
      <Box sx={{ height }}>
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Paper>
  );
}

